module.exports = __webpack_public_path__ + "img/73_01.fac66720.png";